export default __webpack_public_path__ + "static/media/oha.bc7772b0.svg";